<template>
  <b-notification :closable="false">
    <em>{{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-em-1') }}</em
    >{{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-1') }}<br />
    {{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-2') }}<br />
    {{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-3') }}
    <ul style="list-style-type: square; margin-left: 25px">
      <li>
        {{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-li-1') }}
        <a class="link" target="_blank" href="https://www.geonames.org/"
          >geonames</a
        >
      </li>
      <li>
        {{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-li-2') }}
        <b-tooltip
          multilined
          :label="$t('compCarbonFormsTravelsHelpCalculatingMethod.text-tt-1')"
          type="is-black"
        >
          <b-icon icon="info"></b-icon>
        </b-tooltip>
      </li>
      <li>
        {{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-li-3') }}
        <b-tooltip
          multilined
          :label="$t('compCarbonFormsTravelsHelpCalculatingMethod.text-tt-2')"
          type="is-black"
        >
          <b-icon icon="info"></b-icon>
        </b-tooltip>
      </li>
      <li>
        {{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-li-4') }}
        <b-tooltip
          multilined
          :label="$t('compCarbonFormsTravelsHelpCalculatingMethod.text-tt-3')"
          type="is-black"
        >
          <b-icon icon="info"></b-icon>
        </b-tooltip>
      </li>
    </ul>
    <br />
    <em>{{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-em-2') }}</em
    ><br />
    {{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-4') }}<br /><br />
    <em>{{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-em-3') }}</em
    ><br />
    {{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-5') }}<br /><br />
    <em>{{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-em-4') }}</em
    ><br />
    {{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-6') }}<br /><br />
    <em>{{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-em-5') }}</em
    ><br />
    {{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-7') }}<br /><br />
    <em>{{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-em-6') }}</em
    ><br />
    {{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-8') }}<br />
    {{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-9') }}<br /><br />
    <em>{{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-em-7') }}</em
    ><br />
    {{ $t('compCarbonFormsTravelsHelpCalculatingMethod.text-10') }}
  </b-notification>
</template>

<script>
export default {
  name: 'HelpCalculatingMethod'
}
</script>
